import React, { useEffect, useState } from 'react';
import { Sidebar } from '../components/Layout/Sidebar';
import ConfirmationModal from '../components/CreateOrder/ConfirmationModal';
import Topbar from '../components/Layout/Topbar';
import { collection, doc, getDocs, onSnapshot, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../firebase.config';
import { pinCodeList } from "../data/pinCodeData";
import { locationPricing } from '../data/LocationPricing';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import EditOrderPage from '../components/EditOrder/EditOrderPage';
import { createUserNotifications } from '../utils/notificationService';

const EditOrder = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { error } = useSelector((state) => state.order);
  const { userProfile } = useSelector((state) => state.user);
  const actorUserId = userProfile?.id || userProfile?.uid || null

  const [confirmModal, setConfirmModal] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [pickupLocation, setPickupLocation] = useState({});
  const [salesInsuranceCharge, setSalesInsuranceCharge] = useState(0);
  const [user, setUser] = useState({});
  const [dimension, setDimension] = useState([]);
  const [lrDetails, setLrDetails] = useState("manual");
  const [lrNumber, setLrNumber] = useState("");
  const [orderID, setOrderID] = useState("");
  const [pickupZone, setPickupZone] = useState("");
  const [deliveryZone, setDeliveryZone] = useState("");
  const [baseAmount, setBaseAmount] = useState(0);
  const [userList, setUserList] = useState([]);
  const [salesCharge, setSalesCharge] = useState(0);
  const [dimentionData, setDimentionData] = useState({ name: "", qty: "", length: "", width: "", height: "" });
  const [volumetricWeight, setVolumetricWeight] = useState(0);
  const [subOrders, setSubOrders] = useState([]);
  const [dropLocation, setDropLocation] = useState({ address: "", zip: "", consignee: "", city: "", region: "", phone: "" });
  const [mode, setMode] = useState("");
  const [amount, setAmount] = useState(null);
  const [purchaseFuel, setPurchaseFuel] = useState(0);
  const [totalHeight, setTotalHeight] = useState(0);
  const [totalWidth, setTotalWidth] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [weight, setWeight] = useState(null);
  const [consigneeGST, setConsigneeGST] = useState("");
  const [salesTotalCharge, setSalesTotalCharge] = useState(0);
  const [sellerGST, setSellerGST] = useState("");

  const handleConfirmModal = () => setConfirmModal(!confirmModal);

  const handleDimensionData = () => {
    setDimension([...dimension, {
      name: dimentionData.name,
      qty: Number(dimentionData.qty),
      length: Number(dimentionData.length),
      width: Number(dimentionData.width),
      height: Number(dimentionData.height)
    }]);
    setSubOrders([...subOrders, {
      ident: "GRC" + (dimension.length + 1),
      count: Number(dimentionData.qty),
      description: dimentionData.name
    }]);
    setDimentionData({ name: "", qty: "", length: "", width: "", height: "" });
  };

  const removeDimesion = (name) => {
    setDimension(dimension.filter((item) => item.name !== name));
  };

  const [loading, setloading] = useState(false)
  const handleConfirmOrder = async () => {
    setloading(true)
    const date = new Date();
    const volume = (totalHeight * totalWidth * totalLength) / 4500;
    const baseCost = volume * baseAmount;
    const fuelCost = baseCost * 0.2;
    const totalPurchase = baseCost + fuelCost;
    const totalSales = salesCharge + salesInsuranceCharge;

    setVolumetricWeight(volume);
    setAmount(baseCost);
    setPurchaseFuel(fuelCost);
    setSalesTotalCharge(totalSales);

    // Validation
    if (!weight || !orderID || dimension.length === 0) return toast.error("Missing order details");
    if (Object.values(dropLocation).some(val => !val)) return toast.error("Please enter all delivery details");

    const updatedOrderData = {
      ident: "",
      createdAt: date,
      pickup_location: pickupLocation,
      dropoff_location: dropLocation,
      return_address: dropLocation,
      d_mode: "Prepaid",
      purchaseCharge: totalPurchase,
      salesCharge: totalSales,
      payment_mode: "Prepaid",
      rov_insurance: user?.insuranceType,
      invoices: invoiceList,
      weight,
      suborders: subOrders,
      dimensions: dimension,
      consignee_gst_tin: consigneeGST,
      seller_gst_tin: sellerGST,
      cb: {},
      orderID,
      lrno: lrNumber,
      totalLength,
      totalWidth,
      totalHeight,
      masterAWB: "",
      uid: user?.uid,
      userName: user?.name
    };

    try {
      const orderRef = doc(db, "logisticOrder", id); // `id` from useParams
      await updateDoc(orderRef, updatedOrderData);

      // Update user's bill amount
      const repairRef = doc(db, "users", user?.uid);
      await updateDoc(repairRef, {
        billAmount: (userProfile?.billAmount || 0) + totalSales
      });

      toast.success("Order updated successfully");
      await createUserNotifications({
        recipientUserIds: [user?.uid || user?.id],
        actorUserId,
        eventType: 'order_updated',
        title: 'Order updated',
        message: `Order ${lrNumber || orderID || id} was updated.`,
        entityType: 'order',
        metadata: {
          orderId: id,
          orderReference: lrNumber || orderID || id,
        },
      })
      navigate("/success");
      setloading(false)
    } catch (err) {
      console.error("Error updating order:", err);
      toast.error("Failed to update order");
    }
  };

  const fetchWarehouse = async () => {
    const q = query(collection(db, "warehouse"), where("userUid", "==", user.uid));
    const querySnapshot = await getDocs(q);
    const warehouses = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setWarehouseList(warehouses);
  };

  const fetchUsers = async () => {
    const q = query(collection(db, "users"), where("service", "==", "logistics"));
    const querySnapshot = await getDocs(q);
    const users = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setUserList(users);
  };

  const getUserFromID = (id) => {
    onSnapshot(doc(db, "users", id), (doc) => setUser(doc.data()));
  };

  const fetchOrderDetail = () => {
    onSnapshot(doc(db, "logisticOrder", id), (doc) => {
      const data = doc.data();
      setPickupLocation(data?.pickup_location);
      setDropLocation(data?.dropoff_location);
      setDimension(data?.dimensions);
      setInvoiceList(data?.invoices);
      setLrNumber(data?.lrno);
      setOrderID(data?.orderID);
      setWeight(Number(data?.weight));
      setSubOrders(data?.suborders);
      setConsigneeGST(data?.consignee_gst_tin || "");
      setSellerGST(data?.seller_gst_tin || "");
      getUserFromID(data?.uid);
    });
  };

  // Fetch users only once
  useEffect(() => {
    fetchUsers();
  }, []);

  // Fetch order details only once
  useEffect(() => {
    fetchOrderDetail();
  }, [id]);

  // Fetch warehouse only when user is fully set
  useEffect(() => {
    if (user?.uid) {
      fetchWarehouse();
    }
  }, [user]);


  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const fetchDeliveryAddresses = async () => {
    const querySnapshot = await getDocs(collection(db, 'deliveryAddresses'));
    const addresses = querySnapshot.docs.map(doc => doc.data());
    setDeliveryAddresses(addresses);
  };

  useEffect(() => {
    fetchDeliveryAddresses();
  }, []);


  console.log(deliveryAddresses)



  return (
    <div className='bg-gray-100 flex'>
      <Toaster />
      <Sidebar />
      <ConfirmationModal confirmModal={confirmModal} handleBookOrder={handleConfirmOrder} handleConfirmModal={handleConfirmModal} />
      <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col'>
        <Topbar />
        <EditOrderPage
          deliveryAddresses={deliveryAddresses}
          loading={loading}
          setloading={setloading}
          invoiceList={invoiceList}
          handleConfirmOrder={handleConfirmOrder}
          setInvoiceList={setInvoiceList}
          userList={userList}
          setUserList={setUserList}
          user={user}
          setUser={setUser}
          handleBookOrder={handleConfirmOrder}
          handleDeliveryInformation={() => { }}
          warehouseList={warehouseList}
          pickupLocation={pickupLocation}
          setPickupLocation={setPickupLocation}
          handleShippingDetails={() => { }}
          removeDimesion={removeDimesion}
          handleDimensionData={handleDimensionData}
          dimentionData={dimentionData}
          setDimentionData={setDimentionData}
          setDimension={setDimension}
          dimension={dimension}
          subOrders={subOrders}
          setSubOrders={setSubOrders}
          dropLocation={dropLocation}
          setDropLocation={setDropLocation}
          mode={mode}
          setMode={setMode}
          amount={amount}
          setAmount={setAmount}
          weight={weight}
          setWeight={setWeight}
          lrNumber={lrNumber}
          setLrNumber={setLrNumber}
          orderID={orderID}
          setOrderID={setOrderID}
          lrDetails={lrDetails}
          setLrDetails={setLrDetails}
        />
      </div>
    </div>
  );
};

export default EditOrder;
